<template>
  <div
    class="user-detail"
  >
    <h3
      v-if="!noHeader"
    >
      {{ header }}

      <router-link
        v-if="userId"
        class="btn btn-primary btn-sm float-right"
        :to="{
          name: 'edit_user_details',
          id: userId
        }"
      >
        Edit
      </router-link>
    </h3>

    <div
      v-if="userDetail"
    >
      <div
        class="user-detail-portrait"
      >
        <table
          class="table"
        >
          <tr>
            <td>
              Portrait
            </td>
            <td>
              <span
                v-if="userDetail.portrait_url"
                class="text-center"
              >
                <img
                  :src="userDetail.full_portrait_url"
                />
              </span>
              <span
                v-else
              >
                No Portrait Available
              </span>
            </td>
          </tr>
          <tr>
            <td
              colspan="2"
            >
              <p>
                User Summary
              </p>
              <blockquote
                v-if="userDetail.summary"
                class="blockquote pt-1 pb-1 pl-2 pr-2"
              >{{ userDetail.summary }}</blockquote>
              <p
                v-else
                class="alert alert-warning text-center"
              >
                No Summary Available
              </p>
            </td>
          </tr>
          <tr>
            <td
              colspan="2"
            >
              <p>
                User Bio/Profile
              </p>
              <p
                v-if="userDetail.bio"
                class="alert alert-warning"
                v-html="userDetail.bio"
              ></p>
              <p
                v-else
                class="alert alert-warning text-center"
              >
                No Profile Available
              </p>
            </td>
          </tr>
          <tr>
            <td>
              Pronouns
            </td>
            <td>
              {{ userDetail.pronouns || 'None Entered' }}
            </td>
          </tr>
        </table>
        <table v-if="userDetail.social_urls">
          <tr>
            <td>
              Twitter Handle
            </td>
            <td>
              <a
                v-if="userDetail.social_urls.twitter"
                :href="`https://twitter.com/${userDetail.social_urls.twitter}`"
                target="_blank"
              >{{ userDetail.social_urls.twitter }}</a>
              <span
                v-else
              >
                n/a
              </span>
            </td>
          </tr>
          <tr>
            <td>
              Instagram Handle
            </td>
            <td>
              <a
                v-if="userDetail.social_urls.instagram"
                :href="`https://instagram.com/${userDetail.social_urls.instagram}`"
                target="_blank"
              >{{ userDetail.social_urls.instagram }}</a>
              <span
                v-else
              >
                n/a
              </span>
            </td>
          </tr>
          <tr>
            <td>
              User Website
            </td>
            <td>
              <a
                v-if="userDetail.social_urls.author_url"
                :href="userDetail.social_urls.author_url"
                target="_blank"
              >{{ userDetail.social_urls.author_url }}</a>
              <span
                v-else
              >
                n/a
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    header: {
      type: String,
      default: 'User Profile'
    },

    noHeader: {
      type: Boolean
    },

    userUserDetail: {
      type: Object
    },

    userId: {
      type: [ Number, String ]
    }
  },

  computed: mapState({
    base: state => state.base,
    userDetail: state => state.UserDetailModule.user_detail
  }),

  created () {
    if (this.userId) {
      this.get().then(resp => {
        if (!this.userDetail.id) {
          this.store()
        }
      })
    } else {
      this.store()
    }
  },

  methods: {
    store () {
      this.$store.dispatch(
        `UserDetailModule/storeUserDetails`, this.userUserDetail
      )
    },

    get () {
      return this.$store.dispatch(
        `UserDetailModule/getUserDetails`, this.userId
      ).catch(this.$root.processErrors)
    }
  }
}
</script>

<style scoped>
  blockquote {
    font-size: 1.1rem;
    max-height: 11rem;
    overflow-y: scroll;
    white-space: pre-line;
  }

  .user-detail-portrait img {
    max-height: 400px;
    max-width: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserDetail.vue